import { useEffect, useState } from "react";
import { Phone, MessageSquare } from "lucide-react";

/**
 * Compact mobile quick-contact bar. Stays hidden until the visitor has
 * scrolled past the hero so it doesn't compete with the hero CTAs.
 */
export function MobileStickyBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const threshold = Math.min(window.innerHeight * 0.8, 620);
      setShow(window.scrollY > threshold);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 lg:hidden shadow-[0_-2px_12px_rgba(0,0,0,0.15)] transition-transform duration-200 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      role="navigation"
      aria-label="Quick contact"
      aria-hidden={!show}
    >
      <a
        href="tel:+14809415373"
        tabIndex={show ? undefined : -1}
        className="flex h-12 items-center justify-center gap-1.5 bg-primary text-white text-[14px] font-semibold"
      >
        <Phone className="h-4 w-4" aria-hidden="true" />
        Call
      </a>
      <a
        href="sms:+14809415373"
        tabIndex={show ? undefined : -1}
        className="flex h-12 items-center justify-center gap-1.5 bg-accent text-primary text-[14px] font-semibold"
      >
        <MessageSquare className="h-4 w-4" aria-hidden="true" />
        Text
      </a>
    </div>
  );
}
